import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";
import { fwfOptionsSchema } from "../fwf-shared";

export const fwfDataSourceWriterStep = defineStepConfig({
  type: "fwf_datasource_writer",
  name: "Fwf DataSource Writer",
  description:
    "Load a fixed-width file chunk from Blob Storage into a configured DataIngestLink target.",
  category: "DataSource Writer",

  inputSchema: z.object({
    blobStorageUri: z
      .string()
      .describe("Blob Storage URI of the fixed-width file chunk to load"),
    storageProfile: z
      .string()
      .describe(
        "Storage profile key that identifies the credentials to use to access the Blob Storage URI",
      ),
    dataSourceLink: z
      .string()
      .uuid()
      .describe("DataIngestLink that identifies the target schema + table"),
    fwfOptions: fwfOptionsSchema.describe(
      "Fixed-width file parsing options propagated from the upstream Fwf DataSource Adapter step.",
    ),
  }),

  outputSchema: z.object({}),

  configSchema: z.object({
    batchSize: z
      .number()
      .int()
      .positive()
      .prefault(500)
      .describe("Number of records per write batch"),
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "10 minutes",
    retry: {
      maximumAttempts: 3,
      backoffCoefficient: 2,
      initialInterval: "10 seconds",
    },
  },
});
